import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const QueuesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/PrintConditions",
    $_paramApiPath: "v1.0/Audit",
    $_PrintConditions: [],
    $_currentPrintCondition: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allPrintConditions: (state) => state.$_PrintConditions,
    currentPrintCondition: (state) => state.$_currentPrintCondition,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initPrintCondition({ commit }) {
      var printConditions = {
        isNew: true,
        conditionId: 0,
        companyId: 0,
        macroLineId: null,
        lineId: null,
        branchOfficeId: null,
        businessUnitId: null,
        endorsementTypeId: null,
        endorsementSubTypeId: null,
        // productId: null,
        agentId: null,
        holderId: null,
        validFrom: null,
        validThru: null,
        policyNumber: null,
        printEnabled: false,
        isActive: false,
        packages: [],
        documents: [],
        formats: [],
        integrations: []
      };

      commit("SET_PRINTCONDITION", printConditions);
    },
    getDefaultPrintCondition() {
      var printConditions = {
        isNew: true,
        conditionId: 0,
        companyId: 0,
        macroLineId: null,
        lineId: null,
        branchOfficeId: null,
        businessUnitId: null,
        endorsementTypeId: null,
        endorsementSubTypeId: null,
        // productId: null,
        agentId: null,
        holderId: null,
        validFrom: null,
        validThru: null,
        policyNumber: null,
        printEnabled: false,
        isActive: false,
        packages: [],
        documents: [],
        formats: [],
        integrations: []
      };

      return printConditions;
    },
    clearPrintConditions({ commit }) {
      commit("SET_PRINTCONDITIONS", []);
    },
    setPrintCondition({ commit }, printConditions) {
      commit("SET_PRINTCONDITION", printConditions);
    },
    async getPrintConditions({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PRINTCONDITIONS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getPrintCondition(
      { commit, dispatch, state, rootGetters },
      conditionId
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + conditionId;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PRINTCONDITION", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getTableData(
      { commit, dispatch, state, rootGetters },
      { schema, name }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_paramApiPath +
        "/GetAuditableTableData/" +
        schema +
        "/" +
        name;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        var response = await axios.get(actionLink, axiosConfig);
        return response.data || {};
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createPrintCondition(
      { commit, dispatch, state, rootGetters },
      printConditions
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        printConditions.id = 0;
        const response = await axios.post(
          actionLink,
          printConditions,
          axiosConfig
        );
        printConditions.id = response.data.id;
        commit("SET_PRINTCONDITION", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updatePrintCondition({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.conditionId;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data, axiosConfig);

        commit("SET_PRINTCONDITION", response);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deletePrintCondition({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.conditionId;
      var axiosConfig = rootGetters.axiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data;
      try {
        const response = await axios.delete(actionLink, $_axiosConfig);
        data.id = response.data.id;
        commit("SET_PRINTCONDITION", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async validateExists(
      { commit, dispatch, state, rootGetters },
      printConditions
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/ValidateExists";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(
          actionLink,
          printConditions,
          axiosConfig
        );
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getPrintConditionHierarchy(
      { commit, dispatch, state, rootGetters },
      printConditions
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_moduleApiPath + "/GetConditionHierarchy";
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.post(
          actionLink,
          printConditions,
          axiosConfig
        );
        console.log(response);
        if (response.data == "") return null;

        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_PRINTCONDITIONS(state, value) {
      state.$_PrintConditions = value;
    },
    SET_PRINTCONDITION(state, value) {
      state.$_currentPrintCondition = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default QueuesVuexModule;
